import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'rax-logged-out',
    templateUrl: './logged-out-page.component.html',
    imports: [MatButtonModule],
})
export class LoggedOutPage {
    public onLogInAgainButtonClick(): void {
        window.location.href = window.location.protocol + '//' + window.location.host;
    }
}
